import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.08915 14.4514C6.20903 14.537 6.35267 14.5831 6.49998 14.5831C6.6473 14.5831 6.79093 14.537 6.91081 14.4514C7.12615 14.2991 12.1872 10.6448 12.1666 6.08317C12.1666 2.95871 9.62444 0.416504 6.49998 0.416504C3.37552 0.416504 0.833314 2.95871 0.833314 6.07963C0.812773 10.6448 5.87381 14.2991 6.08915 14.4514ZM6.49998 1.83317C8.84386 1.83317 10.75 3.7393 10.75 6.08671C10.7649 9.2303 7.64181 12.053 6.49998 12.9788C5.35886 12.0523 2.23511 9.22888 2.24998 6.08317C2.24998 3.7393 4.15611 1.83317 6.49998 1.83317Z"
      fill="#BABABA"
    />
  </svg>,
  "LocationIcon"
);
